import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Role } from 'src/app/_models/role';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorPageComponent {
  Role = Role;

  /** Title text to display on the error page (optional, default: 'Error') */
  title = input<string>('Error');

  /** Primary body text for the error page (required) */
  primaryText = input<string>();
}
